import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69c0e7967d947e00146843ba/showcrm/src/app/events-list/components/EventsListContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69c0e7967d947e00146843ba/showcrm/src/components/Sidebar.tsx");
